import FlexibleMeetingSuggestionsControl from "#webapp/src/components/flexible-meeting-suggestions-control";
import OtherFlexMeetings from "#webapp/src/components/my-flexible-meetings/MyFlexibleMeetings";
import OneOnOnesControl from "#webapp/src/components/one-on-one-control";
import {
  DisabledWrapper,
  flexibilityExpiredTooltipCopy,
} from "@clockwise/web-commons/src/ui/disabled-wrapper";
import classNames from "classnames";
import React from "react";
import { useMonetization } from "../../hooks/useMonetization";
import { shouldHighlightFlexibleMeetings } from "../ui-focus-wrappers/ui-focus.utils";

const FlexibleMeetings = () => {
  const { canUserAccessFlexMeetings } = useMonetization();

  return (
    <>
      <div
        className={classNames("cw-mb-12", {
          "cw-animate-serene-spotlight": shouldHighlightFlexibleMeetings(),
        })}
      >
        <OneOnOnesControl />
      </div>
      <DisabledWrapper
        isDisabled={!canUserAccessFlexMeetings}
        tooltipBody={flexibilityExpiredTooltipCopy.body}
        tooltipHeader={flexibilityExpiredTooltipCopy.header}
      >
        <div className="cw-mb-12">
          <FlexibleMeetingSuggestionsControl />
        </div>
      </DisabledWrapper>
      <DisabledWrapper
        isDisabled={!canUserAccessFlexMeetings}
        tooltipBody={flexibilityExpiredTooltipCopy.body}
        tooltipHeader={flexibilityExpiredTooltipCopy.header}
      >
        <div className="cw-mb-12">
          <OtherFlexMeetings excludeOneOnOnes={true} />
        </div>
      </DisabledWrapper>
    </>
  );
};

export default FlexibleMeetings;
